// extracted by mini-css-extract-plugin
module.exports = {"headCell":"comparePricesArray_headCell__3sJ3s","mainCell":"comparePricesArray_mainCell__2qdkv","firstColumn":"comparePricesArray_firstColumn__1Ny-y","firstRow":"comparePricesArray_firstRow__2YIRi","row":"comparePricesArray_row__3aooZ","oddRow":"comparePricesArray_oddRow__3l-1S","hiddenMobile":"comparePricesArray_hiddenMobile__1IXvc","hiddenDesktop":"comparePricesArray_hiddenDesktop__3t4Uh"};
    if(module.hot) {
      // 1745908353154
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  